import React from "react";
import { useTranslation } from "react-i18next";

export default function DeleteAction({ disabled, onClick }) {
  const { t } = useTranslation();
  const label = t("admin.deleteButton", { defaultValue: "Delete" });
  return (
    <button
      type="button"
      className="icon-btn indexes-delete-icon-btn"
      onClick={onClick}
      disabled={disabled}
      title={label}
      aria-label={label}
    >
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m2 0v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    </button>
  );
}
